<app-date-input [group]="group" >
</app-date-input>